import { render, staticRenderFns } from "./TopVideo.vue?vue&type=template&id=1affa5c6&scoped=true"
import script from "./TopVideo.vue?vue&type=script&lang=js"
export * from "./TopVideo.vue?vue&type=script&lang=js"
import style0 from "./TopVideo.vue?vue&type=style&index=0&id=1affa5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1affa5c6",
  null
  
)

export default component.exports